import React, { useState } from "react";
import "./PaymentPage.css";

const MONTHLY_PRICE = 3.99;
const ANNUAL_PRICE = 29.99;
const ANNUAL_SAVINGS_PERCENT = Math.round(
  (1 - ANNUAL_PRICE / (MONTHLY_PRICE * 12)) * 100
);

const PaymentPage = () => {
  const [selectedPlan, setSelectedPlan] = useState("annual");

  const handleSubscribe = (plan) => {
    setSelectedPlan(plan);
    alert(
      `Subscribing to the ${plan} plan. (Payment processing not yet connected.)`
    );
  };

  return (
    <div className="payment-page">
      <div className="payment-container">
        <h1 className="payment-title">Unlock Premium Access</h1>
        <p className="payment-subtitle">
          The Advanced topics require a premium subscription. Pick the plan
          that fits you best.
        </p>

        <div className="plans-grid">
          <div
            className={`plan-card ${
              selectedPlan === "monthly" ? "selected" : ""
            }`}
            onClick={() => setSelectedPlan("monthly")}
          >
            <div className="plan-header">
              <h2>Monthly</h2>
            </div>
            <div className="plan-price">
              <span className="price-amount">€3.99</span>
              <span className="price-period">/ month</span>
            </div>
            <ul className="plan-features">
              <li>Full access to all Advanced topics</li>
              <li>Progressive hints and dynamic solutions</li>
              <li>Cancel anytime</li>
            </ul>
            <button
              className="subscribe-button"
              onClick={(e) => {
                e.stopPropagation();
                handleSubscribe("monthly");
              }}
            >
              Subscribe Monthly
            </button>
          </div>

          <div
            className={`plan-card plan-card-featured ${
              selectedPlan === "annual" ? "selected" : ""
            }`}
            onClick={() => setSelectedPlan("annual")}
          >
            <div className="plan-badge">Best value</div>
            <div className="plan-header">
              <h2>Annual</h2>
            </div>
            <div className="plan-price">
              <span className="price-amount">€29.99</span>
              <span className="price-period">/ year</span>
            </div>
            <p className="plan-savings">
              Save {ANNUAL_SAVINGS_PERCENT}% vs. paying monthly
            </p>
            <ul className="plan-features">
              <li>Full access to all Advanced topics</li>
              <li>Progressive hints and dynamic solutions</li>
              <li>Priority access to new content</li>
            </ul>
            <button
              className="subscribe-button subscribe-button-featured"
              onClick={(e) => {
                e.stopPropagation();
                handleSubscribe("annual");
              }}
            >
              Subscribe Annually
            </button>
          </div>
        </div>

        <p className="payment-disclaimer">
          Prices in EUR. You can cancel your subscription at any time.
        </p>
      </div>
    </div>
  );
};

export default PaymentPage;
